var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 22,
    viewBox: "0 0 156 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_3865)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7826 9.4894L9.22143 18.9698L9.21249 18.9788H0L2.67301 16.2266L9.21249 9.49388L2.68642 2.73879L0.0446991 0H9.21249L9.21696 0.00896495L18.7826 9.4894Z",
    fill: "#5D44FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8207 12.8155C34.8207 15.6394 32.7422 17.298 29.3451 17.298H21.3037V1.61377H28.9428C32.1388 1.61377 34.262 3.33952 34.262 5.87212C34.262 7.32893 33.5468 8.42714 32.3846 9.09951C33.8597 9.8167 34.8207 11.0942 34.8207 12.82M24.9243 4.79633V7.93406H28.9473C29.9306 7.93406 30.6458 7.21687 30.6458 6.32037C30.6458 5.42388 29.9306 4.77392 28.9473 4.79633H24.9243ZM29.3496 14.093C30.4894 14.093 31.1375 13.3758 31.1375 12.4569C31.1375 11.4932 30.4894 10.8432 29.3496 10.8432H24.9243V14.093H29.3496Z",
    fill: "white",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8206 11.6051C34.8206 8.17596 37.212 5.55371 40.8549 5.55371C44.4979 5.55371 46.8223 8.17596 46.8223 11.4706C46.8223 11.874 46.7999 12.2774 46.7329 12.6584H38.3116C38.5351 13.7342 39.3173 14.6307 41.15 14.6307C42.3568 14.6307 43.0497 14.1601 43.4296 13.4653L46.6479 14.4066C46.0445 15.8186 44.1224 17.6116 41.0829 17.6116C37.3729 17.6116 34.825 15.1686 34.825 11.6095M43.3357 10.5068C43.224 9.47588 42.3077 8.55697 40.8326 8.55697C39.3575 8.55697 38.4635 9.54312 38.3071 10.5068H43.3357Z",
    fill: "white",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.266 5.87207H59.0833L52.3158 22H48.6729L50.7067 17.029L50.8631 17.0065L50.7067 17.029L45.5886 5.87207H49.4998L52.4723 12.8378L55.266 5.87207Z",
    fill: "white",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.033 11.5828C58.033 8.1537 60.6032 5.55835 64.1567 5.55835C67.7103 5.55835 70.2805 8.15819 70.2805 11.5828C70.2805 15.0074 67.7103 17.6072 64.1567 17.6072C60.6032 17.6072 58.033 15.0074 58.033 11.5828ZM66.8163 11.5828C66.8163 9.96911 65.7883 8.78125 64.1567 8.78125C62.5252 8.78125 61.4971 9.96911 61.4971 11.5828C61.4971 13.1965 62.5252 14.3843 64.1567 14.3843C65.7883 14.3843 66.8163 13.1965 66.8163 11.5828Z",
    fill: "white",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3402 10.6415V17.2935H78.7642V11.3542C78.7642 9.85256 78.1385 8.86642 76.7304 8.86642C75.3224 8.86642 74.5178 9.96462 74.5178 11.7128V17.289H70.9419V5.87212H74.5178V7.05998C75.2777 6.1859 76.4175 5.55835 77.8926 5.55835C80.9321 5.55835 82.3402 7.62029 82.3402 10.646",
    fill: "white",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7941 0.941406H95.2985V17.298H91.7897V16.1773C91.0074 17.0514 89.8676 17.6117 88.4372 17.6117C85.353 17.6117 82.8945 15.0567 82.8945 11.5873C82.8945 8.11785 85.353 5.55836 88.4372 5.55836C89.8899 5.55836 91.0074 6.09625 91.7897 6.99275V0.941406H91.7941ZM91.8165 11.5604C91.8165 9.85705 90.6319 8.73643 89.0898 8.73643C87.5477 8.73643 86.4302 9.85705 86.4302 11.5604C86.4302 13.2637 87.5477 14.4292 89.0898 14.4292C90.6319 14.4292 91.8165 13.2861 91.8165 11.5604Z",
    fill: "white",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.35 13.8913H107.698V17.298H96.6396V0.941406H100.35V13.8913Z",
    fill: "white",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.318 11.6051C107.318 8.17596 109.71 5.55371 113.352 5.55371C116.995 5.55371 119.32 8.17596 119.32 11.4706C119.32 11.874 119.297 12.2774 119.23 12.6584H110.809C111.033 13.7342 111.815 14.6307 113.648 14.6307C114.854 14.6307 115.547 14.1601 115.927 13.4653L119.146 14.4066C118.542 15.8186 116.62 17.6116 113.58 17.6116C109.87 17.6116 107.323 15.1686 107.323 11.6095M115.833 10.5068C115.722 9.47588 114.805 8.55697 113.33 8.55697C111.855 8.55697 110.961 9.54312 110.805 10.5068H115.833Z",
    fill: "white",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.211 5.87212H131.719V17.298H128.211V16.1773C127.428 17.0514 126.288 17.6117 124.858 17.6117C121.774 17.6117 119.315 15.0567 119.315 11.5873C119.315 8.11785 121.774 5.55835 124.858 5.55835C126.311 5.55835 127.428 6.09625 128.211 6.99274V5.87212ZM128.233 11.5604C128.233 9.85705 127.048 8.73643 125.506 8.73643C123.964 8.73643 122.847 9.85705 122.847 11.5604C122.847 13.2637 123.964 14.4292 125.506 14.4292C127.048 14.4292 128.233 13.2861 128.233 11.5604Z",
    fill: "white",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.28 0.941406H144.785V17.298H141.276V16.1773C140.494 17.0514 139.354 17.6117 137.924 17.6117C134.839 17.6117 132.381 15.0567 132.381 11.5873C132.381 8.11785 134.839 5.55836 137.924 5.55836C139.376 5.55836 140.494 6.09625 141.276 6.99275V0.941406H141.28ZM141.298 11.5604C141.298 9.85705 140.114 8.73643 138.572 8.73643C137.03 8.73643 135.912 9.85705 135.912 11.5604C135.912 13.2637 137.03 14.4292 138.572 14.4292C140.114 14.4292 141.298 13.2861 141.298 11.5604Z",
    fill: "white",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.35 14.3619H156V17.2979H145.634V15.0567L151.065 8.80361H145.768V5.87207H155.799V8.11331L150.35 14.3619Z",
    fill: "white",
    fillRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_3865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aef27d1fdfc7c24e7118529b4969019a.svg";
export { ForwardRef as ReactComponent };